import { H5 } from "../../shared/headings";
import { Link } from "gatsby";
import { OutboundLink } from "../../shared/Href";
import React from "react";
import styled from "styled-components";
// import { AnchorLink } from "gatsby-plugin-anchor-links";

const JUMP_LINKS = [
    { label: "Features", url: "https://www.copilot.money/#features-dark" },
    { label: "Pricing", url: "https://www.copilot.money/#pricing-dark" },
    { label: "Team", url: "https://www.copilot.money/about" },
]

const EXPLORE_LINKS = [
    { label: "Features", url: "https://www.copilot.money/#features-dark" },
    { label: "Pricing", url: "https://www.copilot.money/#pricing-dark" },
    { label: "Team", url: "https://www.copilot.money/about" },
]

const PRIVACY_AND_SEC_PATH = "https://www.copilot.money/privacy-and-security";
const HELP_CENTER_PATH = "https://help.copilot.money/";
const CHANGELOG_PATH = "https://www.copilot.money/dispatch";
const TERMS_OF_SERVICE_PATH = "https://www.copilot.money/terms-of-service";
const PRIVACY_POLICY_PATH = "https://www.copilot.money/privacy-policy";
const JOIN_TEAM_PATH = "https://www.copilot.money/careers"

const FooterLinks = ({ isIndexPage }) => {
  return (
    <>
        <OnThisPage>
            <H5>{ isIndexPage ? "On this page" : "Explore" }</H5>
            <LinkList>
                { isIndexPage && JUMP_LINKS.map((link, index) => (
                    <li key={link.label}><a href={link.url} title={link.label}>{link.label}</a></li>
                ))}
                { !isIndexPage && EXPLORE_LINKS.map((link, index) => (
                    <li key={link.label}><a href={link.url} title={link.label}>{link.label}</a></li>
                ))}
            </LinkList>
        </OnThisPage>
        <Elsewhere>
            <H5>Useful links</H5>
            <LinkList>
                <li key="privacy-and-security">
                    <OutboundLink href={PRIVACY_AND_SEC_PATH}>Privacy & Security</OutboundLink>
                </li>
                <li key="help-center">
                    <OutboundLink href={HELP_CENTER_PATH}>Help center</OutboundLink>
                </li>
                <li key="terms-of-service">
                    <OutboundLink href={TERMS_OF_SERVICE_PATH}>Terms of service</OutboundLink>
                </li>
                <li key="privacy-policy">
                    <OutboundLink href={PRIVACY_POLICY_PATH}>Privacy policy</OutboundLink>
                </li>
            </LinkList>
        </Elsewhere>
        <Elsewhere>
            <H5>More about Copilot</H5>
            <LinkList>
                <li key="changelog">
                    <OutboundLink href={CHANGELOG_PATH}>Changelog</OutboundLink>
                </li>
                <li key="join-team">
                    <OutboundLink href={JOIN_TEAM_PATH}>Careers</OutboundLink>
                </li>
            </LinkList>
        </Elsewhere>
    </>
  )
} 


const OnThisPage = styled.div`
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-top: ${props => props.theme.spacing[6]};
    grid-column: col-start / span 12;
    ${props => props.theme.device.tablet} {
        margin-left: 0;
        margin-right: 0;
        margin-top: 0;
        text-align: left;
        grid-column: span 4;
    }
    ${props => props.theme.device.laptop} {
        grid-column: span 2;
    }
`
const Elsewhere = styled(OnThisPage)`
    ${props => props.theme.device.tablet} {
        grid-column: span 8;
    }
    ${props => props.theme.device.laptop} {
        grid-column: span 2;
    }
`
const LinkList = styled.ul`
    list-style-type: none;
    font-size: ${props => props.theme.fontSize.regular};
    font-weight: 600;
    line-height: 1.75;
    & li a {
        text-decoration: none;
        color: ${props => props.theme.color.textLink};
        &:hover {
            color: ${props => props.theme.color.textHighContrast};
        }
    }
`

export default FooterLinks